import type { CustomerGroup } from './types';

/** Manual groups (CM-P0-6). memberIds reference customers in mockCustomers. */
export const mockGroups: CustomerGroup[] = [
  {
    id: 'grp-vip',
    name: 'VIPs',
    description: 'High-value, recognised regulars who get priority service.',
    memberIds: ['cus-1001', 'cus-1004', 'cus-1012'],
    createdAt: '2025-01-10T09:00:00Z',
    updatedAt: '2026-06-16T13:10:00Z',
  },
  {
    id: 'grp-cater',
    name: 'Caterers',
    description: 'Contacts who place large catering orders.',
    memberIds: ['cus-1004'],
    createdAt: '2025-03-02T11:00:00Z',
    updatedAt: '2026-06-09T12:00:00Z',
  },
];
